import React from 'react';
import { ApiIcon } from '@components/icons';
import InfoItem from './InfoItem';

function Platform({ platform, version = '' }) {
  return platform ? (
    <InfoItem icon={<ApiIcon />} text={`${platform} ${version}`} />
  ) : null;
}

export default Platform;
